import React from "react"
import { DrupalPopup } from "./popup.state"
import { SharedBlockLayout } from "../modernBlocks/blocks/shared/sharedBlock.layout"
import { linkWrapper } from "../utils/link"
import { ComponentMountCycle } from "widgets-for-react"
import { addWindowEvents, removeWindowEvents } from "../utils/windowEvents"
import i18next from "i18next"

export const PopupLayout = {
  Dialog: (props: { popup: DrupalPopup, togglePopup: () => void }) => 
  <ComponentMountCycle onMount={() => { (document.querySelector(`#popup-${props.popup.NodeId}`) as HTMLElement)?.focus(), addWindowEvents({type: 'popup', callback: () => props.togglePopup()})}} onUnmount={() => removeWindowEvents({type: 'popup', callback: () => props.togglePopup()})}>
    <dialog id={`popup-${props.popup.NodeId}`} className={`popup popup--${props.popup.Position}`} open={true}>
      <div className="popup__inner ls-spacing ls-gutter">
        <div className="popup__box">
          <div className="popup__header">
            <button
              className="popup__close"
              onClick={(e) => props.togglePopup()}
              onBlur={(e) => {
                if(document.querySelector(`#popup-${props.popup.NodeId}:focus-within`) == null) { props.togglePopup() }
              }}
            >
              <span className="sr-text">{i18next.t("General:ShareCloseSRT")}</span>
              <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--close"></use></svg>
            </button>
            <p className="popup__title title--s">{props.popup.Title}</p>
          </div>

          <div className="popup__message">
            <SharedBlockLayout.ModernImageSrcSet
              image={props.popup.image}
              lazyload={true}
              priority='low'
              classNames="popup__image"
              imageProportions={{
                width: '520',
                height: '243',
              }}
            />

            <div className="popup__content text--styled" dangerouslySetInnerHTML={{ __html: props.popup.Intro }} />

            {props.popup.PrimaryButton && props.popup.PrimaryButton &&
              <div className="popup__footer ls-clickables">
                {props.popup.PrimaryButton &&
                  <div className="ls-clickable">
                    <SharedBlockLayout.Clickable
                      id='popupSecondaryAction'
                      type='link'
                      link={linkWrapper({ title: props.popup.PrimaryButton.Title, url: props.popup.PrimaryButton.Url })}
                      classNames="button button--primary"
                      onClick={() => props.togglePopup()}
                    />
                  </div>
                }
                {props.popup.SecondaryButton &&
                  <div className="ls-clickable">
                    <SharedBlockLayout.Clickable
                      id='popupSecondaryAction'
                      type='link'
                      link={linkWrapper({ title: props.popup.SecondaryButton.Title, url: props.popup.SecondaryButton.Url })}
                      classNames="button button--tertiary"
                      onClick={() => props.togglePopup()}
                    />
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div className="popup__overlay" aria-hidden="true" onClick={(e) => props.togglePopup()} />
    </dialog>
    <button className="skip-link" onClick={(e) => props.togglePopup()} onBlur={(e) => {if(document.querySelector(`#popup-${props.popup.NodeId}:focus-within`) == null) { props.togglePopup() }}}>{i18next.t("General:ShareCloseSRT")}</button>
  </ComponentMountCycle>
}
